import appStore from '../utils/state';

export default class PageHero extends HTMLElement {
  private isHeaderOverHero = false;
  private heroTop = 0;
  private heroBottom = 0;

  private media: HTMLElement | null = null;

  private onScrollBound = this.onScroll.bind(this);
  private onResizeBound = this.onResize.bind(this);
  private onMainNavOpenBound = this.onMainNavOpen.bind(this);
  private onSearchModalOpenBound = this.onSearchModalOpen.bind(this);

  private unsubscribeFromMainNavOpen: (() => void) | null = null;
  private unsubscribeFromSearchModalOpen: (() => void) | null = null;

  connectedCallback(): void {
    this.addEventListeners();
  }

  private addEventListeners(): void {
    this.media = this.querySelector('[data-page-hero-ref="media"]');

    window.addEventListener('scroll', this.onScrollBound, { passive: true });
    window.addEventListener('resize', this.onResizeBound);

    this.unsubscribeFromMainNavOpen = appStore.subscribeKey('isMainNavOpen', this.onMainNavOpenBound);
    this.unsubscribeFromSearchModalOpen = appStore.subscribeKey('isSearchModalOpen', this.onSearchModalOpenBound);

    this.updateBounds();
    this.updateHeaderTheme();
  }

  private removeEventListeners(): void {
    window.removeEventListener('scroll', this.onScrollBound);
    window.removeEventListener('resize', this.onResizeBound);

    if (this.unsubscribeFromMainNavOpen) {
      this.unsubscribeFromMainNavOpen();
      this.unsubscribeFromMainNavOpen = null;
    }

    if (this.unsubscribeFromSearchModalOpen) {
      this.unsubscribeFromSearchModalOpen();
      this.unsubscribeFromSearchModalOpen = null;
    }
  }

  private onScroll(): void {
    this.updateHeaderTheme();
  }

  private onResize(): void {
    this.updateBounds();
    this.updateHeaderTheme();
  }

  private onMainNavOpen(): void {
    this.updateHeaderTheme();
  }

  private onSearchModalOpen(): void {
    this.updateHeaderTheme();
  }

  private updateBounds(): void {
    if (!this.media) {
      return;
    }

    const rect = this.media.getBoundingClientRect();

    this.heroTop = rect.top + window.scrollY;
    this.heroBottom = this.heroTop + rect.height;
  }

  private isHeroIntersectingViewport(): boolean {
    const scrollY = window.scrollY;
    const viewportBottom = scrollY + window.innerHeight;

    return this.heroBottom > scrollY && this.heroTop < viewportBottom;
  }

  private updateHeaderTheme(): void {
    const intersects = this.isHeroIntersectingViewport();
    const isMainNavOpen = appStore.getState().isMainNavOpen;
    const isSearchModalOpen = appStore.getState().isSearchModalOpen;
    const shouldUseHeroHeader = intersects && !isMainNavOpen && !isSearchModalOpen;

    if (shouldUseHeroHeader === this.isHeaderOverHero) {
      return;
    }

    this.isHeaderOverHero = shouldUseHeroHeader;
    document.documentElement.toggleAttribute('data-page-hero-header', shouldUseHeroHeader);
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
    document.documentElement.removeAttribute('data-page-hero-header');
  }
}

customElements.define('page-hero', PageHero);
